module.exports = __webpack_public_path__ + "img/nlv.a69c86b2.svg";